import { render, staticRenderFns } from "./huodongList.vue?vue&type=template&id=17256780&scoped=true&"
import script from "./huodongList.vue?vue&type=script&lang=js&"
export * from "./huodongList.vue?vue&type=script&lang=js&"
import style0 from "./huodongList.vue?vue&type=style&index=0&id=17256780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17256780",
  null
  
)

export default component.exports